import { useTranslation } from 'react-i18next';
import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const Header = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{
      p: 2,
      borderBottom: 1,
      borderColor: 'divider',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
    >
      <Typography variant="h6">
        {t('ActivityCenter_Activity')}
      </Typography>
      <IconButton onClick={onClose} size="small">
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default Header;
